import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Calendar, Clock, ChevronRight, ArrowLeft } from "lucide-react";
import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";
import { blogPosts } from "./Blog";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 },
};

const BlogPost = () => {
  const { slug } = useParams<{ slug: string }>();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <Layout>
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground mb-4">Post Not Found</h1>
            <Link to="/blog" className="btn-primary">Back to Blog</Link>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <SEOHead
        title={`${post.title} | Pondicherry Taxi Blog`}
        description={post.excerpt}
        keywords={`Pondicherry travel, ${post.title.toLowerCase()}, Puducherry guide, best taxi services in pondicherry, taxi services in pondicherry, 24/7 taxi services, Affordable Taxi Services in Pondicherry, Affordable Taxi Fares in Pondicherry, Pondicherry local sightseeing taxi, Pondicherry city tour packages, Pondicherry sightseeing cab service, Pondicherry airport taxi service, Airport pickup and drop Pondicherry, Chennai to Pondicherry airport taxi, Pondicherry to Chennai cab, Daily pickup drop service, Office pickup drop taxi, Chennai Airport drop taxi service, Pondicherry Airport drop Taxi service, Tours and travels in pondicherry, One-way drop taxi service in pondicherry, Local Pondicherry sightseeing(City Tour), Airport transfer (Hotels)pondicherry, Outstation trips pondicherry, corporate cab service in pondicherry`}
        canonical={`https://pondicherry.taxi/blog/${slug}`}
      />

      <section className="pt-12 pb-8 section-padding bg-gradient-to-b from-primary/5 to-transparent">
        <div className="container-custom max-w-3xl">
          <motion.h1 {...fadeUp} className="text-3xl sm:text-4xl font-bold text-foreground">
            {post.title}
          </motion.h1>
          <motion.div {...fadeUp} className="flex items-center gap-4 text-sm text-muted-foreground mt-4">
            <span className="flex items-center gap-1"><Calendar className="w-4 h-4" /> {post.date}</span>
            <span className="flex items-center gap-1"><Clock className="w-4 h-4" /> {post.readTime}</span>
          </motion.div>
        </div>
      </section>

      <section className="section-padding pt-8">
        <div className="container-custom max-w-3xl">
          <motion.article {...fadeUp} className="prose prose-invert prose-sm max-w-none text-muted-foreground">
            {post.content.split("\n\n").map((paragraph, i) => {
              if (paragraph.startsWith("**") && paragraph.endsWith("**")) {
                return <h3 key={i} className="text-xl font-semibold text-foreground mt-8 mb-3">{paragraph.replace(/\*\*/g, "")}</h3>;
              }
              const formatted = paragraph.replace(/\*\*(.*?)\*\*/g, '<strong class="text-foreground">$1</strong>');
              return <p key={i} className="mb-4 leading-relaxed" dangerouslySetInnerHTML={{ __html: formatted }} />;
            })}
          </motion.article>

          <div className="mt-12 pt-8 border-t border-border">
            <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-primary font-medium hover:gap-3 transition-all">
              <ArrowLeft className="w-4 h-4" /> Back to Blog
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default BlogPost;
